import Vue from 'vue';
import { i18n } from '@/i18n';

/**
 * Global translation filter for i18n
 */
Vue.filter('translate', (key: string) => {
  if (!key) {
    return '';
  }
  return i18n.t(key);
});

/**
 * Global translation date filter for i18n
 */
Vue.filter('translateDate', (key: Date) => {
  if (!key) {
    return '';
  }
  return i18n.d(key, 'short');
});
